module.exports = __webpack_public_path__ + "static/media/Appstore.c8c6d5c2.svg";